export const coinflip = (rate: number) => {
  if (rate === 0) {
    return false;
  } else if (rate === 1) {
    return true;
  } else {
    return Math.random() * rate < 1;
  }
};
